import { render } from "./CekPtk.vue?vue&type=template&id=d3995726"
import script from "./CekPtk.vue?vue&type=script&lang=js"
export * from "./CekPtk.vue?vue&type=script&lang=js"

import exportComponent from "d:\\WinNMP\\WWW\\dapodik\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__